import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "nav nav-tabs",
  role: "tablist"
}
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = {
  class: "nav-link active",
  "data-toggle": "tab",
  href: "#tab_default-1",
  role: "tab",
  "aria-selected": "true",
  ref: "tabSales"
}
const _hoisted_4 = { class: "tab-content p-3" }
const _hoisted_5 = {
  class: "tab-pane active",
  id: "tab_default-1",
  role: "tabpanel"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12 input-daterange input-group maisaiToolsRow" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-12 btn-group btn-group-sm" }
const _hoisted_10 = { class: "row ditTableFrame" }
const _hoisted_11 = {
  class: "sales_list",
  id: "sales_list",
  style: {"margin":"0px","padding":"0px","width":"100%","height":"fit-content"}
}
const _hoisted_12 = {
  class: "tab-pane",
  id: "tab_default-2",
  role: "tabpanel"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-12 input-daterange input-group maisaiToolsRow" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-12 btn-group btn-group-sm" }
const _hoisted_17 = { class: "row ditTableFrame" }
const _hoisted_18 = {
  class: "supplier_list",
  id: "supplier_list",
  style: {"margin":"0px","padding":"0px","width":"100%","height":"fit-content"}
}
const _hoisted_19 = {
  class: "tab-pane",
  id: "tab_default-3",
  role: "tabpanel"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-12 btn-group btn-group-sm" }
const _hoisted_24 = { class: "row ditTableFrame" }
const _hoisted_25 = {
  class: "sales_list",
  id: "sales_list",
  style: {"margin":"0px","padding":"0px","width":"100%","height":"fit-content"}
}
const _hoisted_26 = {
  class: "col-md-6",
  style: {"padding-left":"15px"}
}
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-12 btn-group btn-group-sm" }
const _hoisted_29 = { class: "row ditTableFrame" }
const _hoisted_30 = {
  class: "supplier_list",
  id: "supplier_list",
  style: {"margin":"0px","padding":"0px","width":"100%","height":"fit-content"}
}
const _hoisted_31 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_tableJyutu_row_sales = _resolveComponent("Mo_tableJyutu_row_sales")!
  const _component_Mo_tableJyutu_row_supply = _resolveComponent("Mo_tableJyutu_row_supply")!
  const _component_Or_tableClaimNum = _resolveComponent("Or_tableClaimNum")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, "売上明細", 512)
      ]),
      _cache[49] || (_cache[49] = _createElementVNode("li", { class: "nav-item" }, [
        _createElementVNode("a", {
          class: "nav-link",
          "data-toggle": "tab",
          href: "#tab_default-2",
          role: "tab",
          "aria-selected": "false"
        }, "仕入明細 ")
      ], -1)),
      _cache[50] || (_cache[50] = _createElementVNode("li", { class: "nav-item" }, [
        _createElementVNode("a", {
          class: "nav-link",
          "data-toggle": "tab",
          href: "#tab_default-3",
          role: "tab",
          "aria-selected": "false"
        }, "売上・仕入明細 ")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[51] || (_cache[51] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "分割計上総額", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-sm",
                style: {"max-width":"130px","min-width":"50px","text-align":"right"},
                onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.kanmaDel($event))),
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.kanmaIns($event))),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bulk_U_PriceSales) = $event))
              }, null, 544), [
                [_vModelText, _ctx.bulk_U_PriceSales]
              ]),
              _cache[52] || (_cache[52] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "項目", -1)),
              _createVNode(_component_vSelect, {
                class: "meisiTools-select",
                style: {"max-width":"130px","min-width":"40px"},
                options: _ctx.opItemtypeItem,
                label: "label",
                modelValue: _ctx.bulk_U_itemtype_item,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bulk_U_itemtype_item) = $event)),
                reduce: (label) => label.code
              }, null, 8, ["options", "modelValue", "reduce"]),
              _cache[53] || (_cache[53] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "科目", -1)),
              _createVNode(_component_vSelect, {
                class: "meisiTools-select",
                style: {"max-width":"130px","min-width":"60px"},
                options: _ctx.getOpItemtypeSubjects4salse(),
                label: "label",
                modelValue: _ctx.bulk_U_itemtype_subjects,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bulk_U_itemtype_subjects) = $event)),
                reduce: (label) => label.code
              }, null, 8, ["options", "modelValue", "reduce"]),
              _cache[54] || (_cache[54] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "内訳", -1)),
              _createVNode(_component_vSelect, {
                class: "meisiTools-select",
                style: {"max-width":"130px","min-width":"60px"},
                options: _ctx.getOpItemtypeBreakdown4salse(),
                label: "label",
                modelValue: _ctx.bulk_U_itemtype_breakdown,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bulk_U_itemtype_breakdown) = $event)),
                reduce: (label) => label.code
              }, null, 8, ["options", "modelValue", "reduce"]),
              _cache[55] || (_cache[55] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "売上先", -1)),
              _createVNode(_component_vSelect, {
                class: "meisiTools-select",
                options: _ctx.getOpClients(),
                label: "c_client_name",
                modelValue: _ctx.bulk_U_clirnt,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bulk_U_clirnt) = $event)),
                reduce: (label) => label.c_client_id
              }, null, 8, ["options", "modelValue", "reduce"]),
              _createElementVNode("input", {
                type: "button",
                value: "分割",
                class: "form-control form-control-sm meisaiToolsBtn btn-primary",
                style: {"max-width":"60px","margin-left":"10px","border-radius":"4px"},
                id: "splitSales",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.bulk_U_input()))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary waves-effect waves-themed",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addRowSales()))
              }, " 売上明細行追加 "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary waves-effect waves-themed",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.delRowSales4selectes()))
              }, " 売上明細選択行削除 "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary waves-effect waves-themed",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.copyRowSales()))
              }, " 行コピー "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary waves-effect waves-themed",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showModal4ClaimNum()))
              }, " 請求NR取得 "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary waves-effect waves-themed",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortRowUp4Sales()))
              }, " ▲ "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary waves-effect waves-themed",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sortRowDown4Sales()))
              }, " ▼ ")
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _cache[56] || (_cache[56] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "fixhead headUriage cwU_1" }, "行No"),
                  _createElementVNode("th", { class: "fixhead headUriage cwU_2" }, "請求No"),
                  _createElementVNode("th", { class: "fixhead headUriage cwU_3" }, "請求日"),
                  _createElementVNode("th", { class: "fixhead headUriage cwU_4" }, "売上月"),
                  _createElementVNode("th", { class: "fixhead headUriage cwU_5" }, "項目"),
                  _createElementVNode("th", { class: "fixhead headUriage cwU_6" }, "科目"),
                  _createElementVNode("th", { class: "fixhead headUriage cwU_7" }, "内訳"),
                  _createElementVNode("th", { class: "fixhead headUriage cwU_8" }, "売上先"),
                  _createElementVNode("th", { class: "fixhead headUriage cwU_9" }, "金額"),
                  _createElementVNode("th", { class: "fixhead headUriage cwU_10" }, "消費税"),
                  _createElementVNode("th", { class: "fixhead headUriage cwU_11" }, "入金予定日"),
                  _createElementVNode("th", { class: "fixhead headUriage cwU_12" }, "入金完了日"),
                  _createElementVNode("th", { class: "fixhead headUriage cwU_13" }, "備考")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectData.sales, (item) => {
                  return (_openBlock(), _createBlock(_component_Mo_tableJyutu_row_sales, {
                    key: item.c_sales_id,
                    item: item,
                    mastersData: _ctx.mastersData,
                    claims: _ctx.projectData.claims,
                    onSelected: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectRow4Sales($event))),
                    onReCalc: _cache[15] || (_cache[15] = ($event: any) => (_ctx.profitCalc()))
                  }, null, 8, ["item", "mastersData", "claims"]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[57] || (_cache[57] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "分割計上総額", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-sm",
                style: {"max-width":"130px","min-width":"50px","text-align":"right"},
                onFocus: _cache[16] || (_cache[16] = ($event: any) => (_ctx.kanmaDel($event))),
                onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.kanmaIns($event))),
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.bulk_S_PriceSupply) = $event))
              }, null, 544), [
                [_vModelText, _ctx.bulk_S_PriceSupply]
              ]),
              _cache[58] || (_cache[58] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "項目", -1)),
              _createVNode(_component_vSelect, {
                class: "meisiTools-select",
                style: {"max-width":"130px","min-width":"40px"},
                options: _ctx.opItemtypeItem,
                label: "label",
                modelValue: _ctx.bulk_S_itemtype_item,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.bulk_S_itemtype_item) = $event)),
                reduce: (label) => label.code
              }, null, 8, ["options", "modelValue", "reduce"]),
              _cache[59] || (_cache[59] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "科目", -1)),
              _createVNode(_component_vSelect, {
                class: "meisiTools-select",
                style: {"max-width":"130px","min-width":"60px"},
                options: _ctx.getOpItemtypeSubjects4supply(),
                label: "label",
                modelValue: _ctx.bulk_S_itemtype_subjects,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.bulk_S_itemtype_subjects) = $event)),
                reduce: (label) => label.code
              }, null, 8, ["options", "modelValue", "reduce"]),
              _cache[60] || (_cache[60] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "内訳", -1)),
              _createVNode(_component_vSelect, {
                class: "meisiTools-select",
                style: {"max-width":"130px","min-width":"60px"},
                options: _ctx.getOpItemtypeBreakdown4supply(),
                label: "label",
                modelValue: _ctx.bulk_S_itemtype_breakdown,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.bulk_S_itemtype_breakdown) = $event)),
                reduce: (label) => label.code
              }, null, 8, ["options", "modelValue", "reduce"]),
              _cache[61] || (_cache[61] = _createElementVNode("div", { class: "meisaiToolsTitle" }, "仕入先", -1)),
              _createVNode(_component_vSelect, {
                class: "meisiTools-select",
                options: _ctx.getOpSuppliers(),
                label: "c_supplier_name",
                modelValue: _ctx.bulk_S_Supplyer,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.bulk_S_Supplyer) = $event)),
                reduce: (label) => label.c_supplier_id
              }, null, 8, ["options", "modelValue", "reduce"]),
              _createElementVNode("input", {
                type: "button",
                value: "分割",
                class: "form-control form-control-sm meisaiToolsBtn btn-primary",
                style: {"max-width":"60px","margin-left":"10px","border-radius":"4px"},
                id: "splitSales",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.bulk_S_input()))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary waves-effect waves-themed",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.addRowSupply()))
              }, " 仕入明細行追加 "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary waves-effect waves-themed",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.delRowSupply4selectes()))
              }, " 仕入明細選択行削除 "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary waves-effect waves-themed",
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.copyRowSupply()))
              }, " 行コピー "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary waves-effect waves-themed",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.sortRowUp4Supply()))
              }, " ▲ "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary waves-effect waves-themed",
                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.sortRowDown4Supply()))
              }, " ▼ ")
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("table", _hoisted_18, [
              _cache[62] || (_cache[62] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "fixhead headSiire cwS_1" }, "行No"),
                  _createElementVNode("th", { class: "fixhead headSiire cwS_2" }, "請求No"),
                  _createElementVNode("th", { class: "fixhead headSiire cwS_3" }, "計上月"),
                  _createElementVNode("th", { class: "fixhead headSiire cwS_4" }, "項目"),
                  _createElementVNode("th", { class: "fixhead headSiire cwS_5" }, "科目"),
                  _createElementVNode("th", { class: "fixhead headSiire cwS_6" }, "内訳"),
                  _createElementVNode("th", { class: "fixhead headSiire cwS_7" }, "仕入先"),
                  _createElementVNode("th", { class: "fixhead headSiire cwS_8" }, "金額"),
                  _createElementVNode("th", { class: "fixhead headSiire cwS_9" }, "消費税"),
                  _createElementVNode("th", { class: "fixhead headSiire cwS_9-2" }, "請求書着"),
                  _createElementVNode("th", { class: "fixhead headSiireManage cwS_10" }, "支払予定日"),
                  _createElementVNode("th", { class: "fixhead headSiireManage cwS_11" }, "支払確定"),
                  _createElementVNode("th", { class: "fixhead headSiire cwS_12" }, "備考")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectData.supplys, (item) => {
                  return (_openBlock(), _createBlock(_component_Mo_tableJyutu_row_supply, {
                    key: item.c_supply_id,
                    item: item,
                    mastersData: _ctx.mastersData,
                    claims: _ctx.projectData.claims,
                    onSelected: _cache[29] || (_cache[29] = ($event: any) => (_ctx.selectRow4Supply($event))),
                    onReCalc: _cache[30] || (_cache[30] = ($event: any) => (_ctx.profitCalc()))
                  }, null, 8, ["item", "mastersData", "claims"]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed",
                  onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.addRowSales()))
                }, " 売上明細行追加 "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed",
                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.delRowSales4selectes()))
                }, " 売上明細選択行削除 "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed",
                  onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.copyRowSales()))
                }, " 行コピー "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed",
                  onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showModal4ClaimNum()))
                }, " 請求NR取得 "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed",
                  onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.sortRowUp4Sales()))
                }, " ▲ "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed",
                  onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.sortRowDown4Sales()))
                }, " ▼ ")
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("table", _hoisted_25, [
                _cache[63] || (_cache[63] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "fixhead headUriage cwU_1" }, "行No"),
                    _createElementVNode("th", { class: "fixhead headUriage cwU_2" }, "請求No"),
                    _createElementVNode("th", { class: "fixhead headUriage cwU_3" }, "請求日"),
                    _createElementVNode("th", { class: "fixhead headUriage cwU_4" }, "売上月"),
                    _createElementVNode("th", { class: "fixhead headUriage cwU_5" }, "項目"),
                    _createElementVNode("th", { class: "fixhead headUriage cwU_6" }, "科目"),
                    _createElementVNode("th", { class: "fixhead headUriage cwU_7" }, "内訳"),
                    _createElementVNode("th", { class: "fixhead headUriage cwU_8" }, "売上先"),
                    _createElementVNode("th", { class: "fixhead headUriage cwU_9" }, "金額"),
                    _createElementVNode("th", { class: "fixhead headUriage cwU_10" }, "消費税"),
                    _createElementVNode("th", { class: "fixhead headUriage cwU_11" }, "入金予定日"),
                    _createElementVNode("th", { class: "fixhead headUriage cwU_12" }, "入金完了日"),
                    _createElementVNode("th", { class: "fixhead headUriage cwU_13" }, "備考")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectData.sales, (item) => {
                    return (_openBlock(), _createBlock(_component_Mo_tableJyutu_row_sales, {
                      key: item.c_sales_id,
                      item: item,
                      mastersData: _ctx.mastersData,
                      claims: _ctx.projectData.claims,
                      onSelected: _cache[37] || (_cache[37] = ($event: any) => (_ctx.selectRow4Sales($event))),
                      onReCalc: _cache[38] || (_cache[38] = ($event: any) => (_ctx.profitCalc()))
                    }, null, 8, ["item", "mastersData", "claims"]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed",
                  onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.addRowSupply()))
                }, " 仕入明細行追加 "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed",
                  onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.delRowSupply4selectes()))
                }, " 仕入明細選択行削除 "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed",
                  onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.copyRowSupply()))
                }, " 行コピー "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed",
                  onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.sortRowUp4Supply()))
                }, " ▲ "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed",
                  onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.sortRowDown4Supply()))
                }, " ▼ ")
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("table", _hoisted_30, [
                _cache[64] || (_cache[64] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "fixhead headSiire cwS_1" }, "行No"),
                    _createElementVNode("th", { class: "fixhead headSiire cwS_2" }, "請求No"),
                    _createElementVNode("th", { class: "fixhead headSiire cwS_3" }, "計上月"),
                    _createElementVNode("th", { class: "fixhead headSiire cwS_4" }, "項目"),
                    _createElementVNode("th", { class: "fixhead headSiire cwS_5" }, "科目"),
                    _createElementVNode("th", { class: "fixhead headSiire cwS_6" }, "内訳"),
                    _createElementVNode("th", { class: "fixhead headSiire cwS_7" }, "仕入先"),
                    _createElementVNode("th", { class: "fixhead headSiire cwS_8" }, "金額"),
                    _createElementVNode("th", { class: "fixhead headSiire cwS_9" }, "消費税"),
                    _createElementVNode("th", { class: "fixhead headSiire cwS_9-2" }, "請求書着"),
                    _createElementVNode("th", { class: "fixhead headSiireManage cwS_10" }, "支払予定日"),
                    _createElementVNode("th", { class: "fixhead headSiireManage cwS_11" }, "支払確定"),
                    _createElementVNode("th", { class: "fixhead headSiire cwS_12" }, "備考")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectData.supplys, (item) => {
                    return (_openBlock(), _createBlock(_component_Mo_tableJyutu_row_supply, {
                      key: item.c_supply_id,
                      item: item,
                      mastersData: _ctx.mastersData,
                      claims: _ctx.projectData.claims,
                      onSelected: _cache[44] || (_cache[44] = ($event: any) => (_ctx.selectRow4Supply($event))),
                      onReCalc: _cache[45] || (_cache[45] = ($event: any) => (_ctx.profitCalc()))
                    }, null, 8, ["item", "mastersData", "claims"]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Or_tableClaimNum, {
        onModalclosed: _cache[46] || (_cache[46] = ($event: any) => (_ctx.getEmit())),
        ref: "Or_tableClaimNum",
        projectData: _ctx.projectData,
        "onUpdate:projectData": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.projectData) = $event))
      }, null, 8, ["projectData"]),
      _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
        title: _withCtx(() => [
          _cache[65] || (_cache[65] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
        ]),
        body: _withCtx(() => _cache[66] || (_cache[66] = [
          _createElementVNode("br", null, null, -1)
        ])),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.closeModal4ErrorConf())),
              type: "button",
              class: "btn btn-default bootbox-cancel"
            }, " 確認 ")
          ])
        ]),
        _: 1
      }, 512)
    ])
  ], 64))
}